import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { departmentsConfig } from '../../entity/designations/departmentsConfig';
import BaseComponent from '../../components/BaseComponent';

class Departments extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.config = { ...departmentsConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state: {
  app: { isAuthenticated: any; user: any };
}) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

const DepartmentsWrapper = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <Departments
      {...props}
      navigate={navigate}
      location={location}
      params={params}
    />
  );
};

export default connect(mapStateToProps)(DepartmentsWrapper);
